import req from "../../axios/interceptedAxiosInstance";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const getSellers = createAsyncThunk("sellers/getSellers", async () => {
  const response = await req.get("user/seller/product");
  return response.data.data.filter((product) => product.product.length > 0);
});

const initialState = {
  sellers: [],
  loading: true,
};

const sellerSlice = createSlice({
  name: "seller",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSellers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSellers.fulfilled, (state, action) => {
      state.sellers = action.payload;
      state.loading = false;
    });
    builder.addCase(getSellers.rejected, (state, action) => {
      console.log(action);
      state.loading = false;
    });
  },
});
export default sellerSlice.reducer;
